import React from "react";

export const LifeScoreCard = ({ score, label }) => {
  return (
    <div
      className="d-flex align-items-center gap-3 p-4 rounded-4"
      style={{
        border: "1px solid #2A4051",
        backgroundColor: "#121E29",
        width: "241px",
      }}
    >
      <div
        className="d-flex justify-content-center align-items-center text-white fw-bold"
        style={{
          borderRadius: "32px",
          width: "80px",
          height: "40px",
          backgroundColor: "#008CFF",
          fontSize: "20px",
          lineHeight: 1,
        }}
      >
        {score}
      </div>

      <div
        className="text-body-b2"
        style={{
          color: "#C8CED3",
          fontSize: "18px",
          fontWeight: 400,
        }}
      >
        {label}
      </div>
    </div>
  );
};
